import React, { useCallback, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton } from "@mui/material";
import moment from "moment";
// import CommentBox from "../common/ComentBox";
import Members from "./Members";
import { useNavigate } from "react-router-dom";
import Leaderboard from "./Leaderboard";
import { getLeagueLeaderboard } from "../../../api/getLeagueLeaderboard";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

import shareSVG from "../../../assets/customerAssets/icons/share.svg";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90dvw",
  height: "90dvh",
  bgcolor: "#242743",
  border: "1px solid #414466",
  boxShadow: 24,
  display: "flex",
  flexDirection: "column",
  outline: "none",

  //   p: 4,
};

const headStype = {
  padding: "15px 15px",
  borderBottom: "1px solid #414466",
  display: "flex",
  alignItems: "center",
};

const contentStyle = {
  padding: "15px 15px",
  flexGrow: "1",
  display: "flex",
  flexDirection: "column",
  overflow: "auto",
};

const Index = ({ club, setClub }) => {
  const token = useSelector((state) => state.auth.token);
  const [goals, setGoals] = useState(null);

  const fetchClubLeaderBoard = useCallback(async (id, token, data) => {
    const goalsData = await getLeagueLeaderboard(id, token, data);
    if (goalsData.data?.rows?.length > 0) {
      setGoals(goalsData.data.rows);
    } else {
      setGoals([]);
      toast.error(`No Goals Found`);
    }
  }, []);

  useEffect(() => {
    if (club?.id && token) {
      fetchClubLeaderBoard(club?.id, token, {
        month: null,
        year: new Date().getFullYear(),
      });
    }
  }, [club]);

  const navigate = useNavigate();
  return (
    <Box className="view_feature_wrapper view_club_wrapper">
      <Box className="header club_header">
        <IconButton
          onClick={() => {
            navigate("/myaccount");
            // navigate(-1);
          }}
        >
          <ArrowBackIcon sx={{ color: "white" }} />
        </IconButton>

        <Box className="text_div club_text_div">
          <Typography component={"span"} className="title club_title">
            {club?.title}
          </Typography>
        </Box>
      </Box>

      <Box sx={{ borderBottom: "1px solid #414466" }}></Box>
      <Box className="content club_content">
        <Box className="content_a club_content_a">
          <Box className="img_wrapper club_img_wrapper">
            <img src={club?.league_logo} />
          </Box>

                 <Box className={"share-div"}>
            <Button
              onClick={async () => {
                if (club.shareLink) {
                  await navigator.clipboard.writeText(club.shareLink);
                  toast.success("Share link copied!");
                } else {
                  toast.error("No share link found!");
                }
              }}
            >
              <img src={shareSVG} height={20} width={20} alt="share"></img>{" "}
              Share
            </Button>
          </Box>
        </Box>

        <Box className="content_b club_content_b">
          <Typography
            component="p"
            className="content_b_text club_content_b_text"
          >
            <strong>Description: </strong>
            {club?.description}
          </Typography>

          <Typography
            component="p"
            className="content_b_text club_content_b_text"
          >
            <strong>Video From (UK/International): </strong>
            {club?.from_uk ? "England" : "International"}
          </Typography>
          <Typography
            component="p"
            className="content_b_text club_content_b_text"
          >
            <strong>Created By: </strong>
            {club?.league_owner?.fullName}
          </Typography>
          <Typography
            component="p"
            className="content_b_text club_content_b_text"
          >
            <strong>Created On: </strong>
            {moment(club?.createdAt).format("MM/DD/YYYY")}
          </Typography>
          <Typography
            component="p"
            className="content_b_text club_content_b_text"
          >
            <strong>City/Town: </strong>
            {club?.region}
          </Typography>

          <Box className="content_b_a club_content_b_a">
            <Button className="category_button club_category_button">
              {club?.leagueCategory?.name}
            </Button>
            {club?.leagueSubCategory ? (
              <Button className="category_button club_category_button">
                {club?.leagueSubCategory?.name}
              </Button>
            ) : null}
            <Button className="category_button club_category_button">
              {club?.visibility ? "Public" : "Private"}
            </Button>
          </Box>
        </Box>

        <Members members={club?.leagueMembers} />

        <Leaderboard
          setTournamentData={setClub}
          goals={goals}
          club_logo={club.league_logo}
          fetchLeaderboard={fetchClubLeaderBoard}
          leagueData={club}
        />
      </Box>
    </Box>
  );
};

export default Index;
